import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-page-type"]

import PartnerModal from '@/components/PartnerModal.vue';

import {
  defineComponent,
  shallowRef,
  computed,
  nextTick,
  reactive,
  watch,
  ref, onMounted,
} from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import PageInterface from '@/interfaces/PageInterface';


export default /*#__PURE__*/_defineComponent({
  props: {
  noFetch: {
    type: Boolean,
    required: false,
    default: () => false,
  },
},
  setup(__props) {

const props = __props



const route = useRoute();
const store = useStore();
const pageType = computed(() => route.meta.type);
const partner = computed(() => store.getters['partner/current']);
const show = reactive({ value: false });
const partnerValid = ref(false);
const slug = computed(() => route.params.pageSlug);

const showPartnerModal = computed(() => (
  pageType.value === 'partner'
    && partner.value !== null
    && !partner.value.validated
    && !partnerValid.value
));

const fetch = () => {
  if (props.noFetch) {
    if (window.ioInitialPageData) {
      delete window.ioInitialPageData;
    }

    return;
  }

  const preview = route.query.preview === 'true';

  if (window.ioInitialPageData) {
    store.dispatch('page/setInitialPageData', {
      page: window.ioInitialPageData,
      preview,
    });

    const ioInitialPageDataScript = document.querySelector('script#io-initial-page-data');
    if (ioInitialPageDataScript) {
      ioInitialPageDataScript.remove();
    }

    delete window.ioInitialPageData;
  } else if (slug.value) {
    store.dispatch('page/fetchBySlug', {
      slug: slug.value,
      preview,
    });
  } else {
    store.dispatch('page/fetchFrontPage');
  }
};

watch(() => slug.value, () => {
  fetch();
});

const page = computed<PageInterface | null>(() => store.getters['page/page']);
const status = computed(() => store.getters['page/status']);
const pageContent = reactive({
  component: shallowRef(defineComponent({
    template: '<div class="page-content"></div>',
  })),
});

const updateAdminBar = () => {
  const $wpAdminBarCustomizer = document.querySelector('#wp-admin-bar-customize > a');
  const $wpAdminBarEdit = document.querySelector('#wp-admin-bar-edit > a');

  if ($wpAdminBarCustomizer) {
    $wpAdminBarCustomizer.setAttribute('href', `/wp-admin/customize.php?url=${window.location.origin}${route.path}`);
  }

  if ($wpAdminBarEdit && page.value) {
    $wpAdminBarEdit.setAttribute('href', `/wp-admin/post.php?post=${page.value.id}&action=edit`);
  }
};

const updateMeta = () => {
  if (!page.value) return;

  const title = page.value?.meta?.title || page.value?.title || '';
  const is404 = page.value?.is404 || true;
  const blogPublic = page.value?.blogPublic || false;
  const description = page.value?.meta?.description;
  const yoastHtml = page.value?.meta?.yoastHead?.html;

  let headerHtml = document.head.innerHTML.replace(/<!-- This site is optimized with the Yoast SEO plugin v([1-9]\d*(\.[1-9]\d*){0,3}) - https:\/\/yoast.com\/wordpress\/plugins\/seo\/ -->((.|[\n|\r|\r\n])*?)<!-- \/ Yoast SEO plugin. -->?/sg, '');

  headerHtml = headerHtml.replace(/<title>(.*?)<\/title>/sg, `<title>${title}</title>`);
  headerHtml = headerHtml.replace(/<meta name="description" content="(.*?)">/sg, `<meta name="description" content="${description}">`);

  const hasHeaderRobots = /<meta name="robots" content="(.*?)">/sg.test(headerHtml);
  const hasYoastRobots = /<meta name="robots" content="(.*?)">/sg.test(yoastHtml || '');

  if (hasHeaderRobots && hasYoastRobots) {
    headerHtml = headerHtml.replace(/<meta name="robots" content="(.*?)">/sg, '');
  } else if (hasHeaderRobots && !hasYoastRobots) {
    headerHtml = headerHtml.replace(/<meta name="robots" content="(.*?)">/sg, `<meta name="robots" content="${blogPublic ? 'index, follow' : 'noindex, nofollow'}">`);
  } else if (!hasHeaderRobots && !hasYoastRobots) {
    if (is404 || !blogPublic) {
      headerHtml += '<meta name="robots" content="noindex, follow">';
    } else {
      headerHtml += '<meta name="robots" content="index, follow">';
    }
  }

  headerHtml += yoastHtml || '';

  document.head.innerHTML = headerHtml;
};

watch(() => page.value, () => {
  pageContent.component = defineComponent({
    template: `<div class="page-content">${page.value?.content}</div>`,
  });

  nextTick(() => {
    show.value = true;
    setTimeout(() => {
      window.runIoEqualize();
      window.dispatchEvent(new Event('fetched'));
    }, 100);
  });

  const $wpAdminBar = document.querySelector('#wpadminbar');
  if ($wpAdminBar) {
    updateAdminBar();
  }

  updateMeta();
}, {
  immediate: true,
});

const closeSidebar = () => {
  store.dispatch('sidebar/close');
};

onMounted(() => {
  fetch();
});

return (_ctx: any,_cache: any) => {
  const _component_BaseLoader = _resolveComponent("BaseLoader")!

  return (_openBlock(), _createElementBlock("div", {
    "data-page-type": _unref(pageType),
    onClick: closeSidebar
  }, [
    _createVNode(_Transition, { name: "page-expand" }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_unref(pageContent).component), null, null, 512)), [
          [_vShow, _unref(status) !== 1 && _unref(page)]
        ])
      ]),
      _: 1
    }),
    (_unref(status) === 1)
      ? (_openBlock(), _createBlock(_component_BaseLoader, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(showPartnerModal))
      ? (_openBlock(), _createBlock(PartnerModal, {
          key: 1,
          partner: _unref(partner),
          onValid: _cache[0] || (_cache[0] = ($event: any) => (partnerValid.value = true))
        }, null, 8, ["partner"]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})